import { Container, Row, Col, Button, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import Select from '../../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import ImageUploader from '../../../components/UI/ImageUploader/ImageUploader';
import AutoComplete from '../../../components/UI/AutoComplete/AutoComplete';
import React from 'react';
import { LinearProgress } from '@material-ui/core';

const AddContract = () => {
  const { submitHandler, resetFormState, loading, field, establishments, back } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('contract.title.add')} subtitle={t('contract.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4 py-5 px-4">
              <form>
                <Row>
                  <Col md="6">
                    <Input
                      type="date"
                      placeholder={t('placeholder.start_date')}
                      label={t('label.start_date')}
                      {...field('contractStartDate')}
                    />
                  </Col>

                  <Col md="6">
                    <Input
                      type="date"
                      placeholder={t('placeholder.end_date')}
                      label={t('label.end_date')}
                      {...field('contractEndDate')}
                    />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.status')} label={t('label.status')} {...field('status')}>
                      <option value="" disabled selected>
                        {t('label.status')}
                      </option>
                      <option value="ENABLED">{t('label.enabled')}</option>
                      <option value="DISABLED">{t('label.disabled')}</option>
                    </Select>
                  </Col>

                  <Col md="6">
                    <AutoComplete
                      placeholder={t('placeholder.establishment')}
                      label={t('label.establishment')}
                      {...field('establishment', 'autoComplete')}
                      data={establishments}
                      valueObject="id"
                      titleObject="name"
                    />
                  </Col>

                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="info" disabled={loading} onClick={() => back()}>
                      {t('annuler')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('create')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddContract;
